<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-25 09:34:00
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 10:39:00
 -->
<!--  -->
<template>
  <div class="roleSelect">
    <el-tag
        v-for="tag in roleArry"
        :key="tag.index"
        size="medium "

        :disable-transitions="true"
        @close="handleClose(tag)">
        {{tag.name}}
    </el-tag>
    <el-button icon="el-icon-plus"  circle class="button-new-tag" size="small" @click="addRole" />

  <!-- 选择弹窗 -->
  <el-dialog  class="avue-dialog" title="机构选择器" :visible.sync="modeShow" width="40%"  top="10vh" :append-to-body="true">
    <el-scrollbar style="height:400px;">
      <el-tree ref="cancatTree" lazy :load="loadNodes" check-strictly  show-checkbox   :props="defaultProps"    node-key="id">
      </el-tree>
    </el-scrollbar>
    <div class="avue-form__menu avue-form__menu--center">
                 <el-button type="primary" @click="sure">确 定</el-button>
                <el-button type="info" @click="modeShow =false">取 消</el-button>
            </div>
  </el-dialog>

  </div>
</template>

<script>
import { deepClone } from '@/framework/util/util.js'
export default {
  model: {
    prop: 'value',
    event: 'up'
  },
  props: {
    value: {
      default: () => []
    }
  },
  data() {
    return {
      roleArry: deepClone(this.value),
      modeShow: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      concatTree: {}
    }
  },

  components: {},

  methods: {
    handleClose(tag) {
      let temp = this.value.filter(item => item.id !== tag.id)
      this.roleArry = temp
      this.$emit('up', this.roleArry)
    },
    addRole: function() {
      this.modeShow = true
    },
    loadNodes: function(node, resolve) {
      // TODO:  判断哪科树加载
      if (node.level === 0) {
        this.concatTree.node = node
        this.concatTree.resolve = resolve
        return resolve([{ name: '机构管理系统根', permissionSubjectId: '' }])
      }
      this.$http.post('/org/list', { 'entity': {
        'parentPermissionSubjectId': node.data.permissionSubjectId
      }}).then(response => {
        return resolve(response.data)
      }).catch(error => {
        this.$message.error('节点展开失败,错误原因:' + error.msg)
        return resolve([])
      })
    },
    sure: function() {
      let data = this.$refs.cancatTree.getCheckedNodes()
      if (data && data.length) {
        let temp = data.filter(item => item.id).map(item => { return { 'name': item.name, 'id': item.id } })
        this.roleArry = temp
        this.$emit('up', this.roleArry)
        this.modeShow = false
      } else {
        // return this.$message.error('请选择一个机构')
        this.roleArry = []
        this.$emit('up', this.roleArry)
        this.modeShow = false
      }
    }

  }
}

</script>
<style lang="scss">
.roleSelect{
  .el-tag {
    margin-left: 0.625rem;
  }
  .button-new-tag {
    margin-left: 0.625rem;
    height: 2rem;
    line-height: 1.875rem;
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
<style lang='scss' scoped>
.roleSelect{
    font-size: 0.875rem;
    width: 100%;

    border-radius:5px;
    background-color:transparent;
    border:1px solid #DCDFE6;
}
</style>
